import reframe, { parametric, pathSubscription, subscription } from 'nike-re-framejs';
import { registerClocksSub } from '@/events/services/clocks';

registerClocksSub('nikeoneScoreboard.clock', ['nikeone', 'clock']);

reframe.regSub('nikeone.live.bet', (db, [_, matchId, betId]) => db.getIn(['nikeone', 'live', matchId, 'bets', betId]));

reframe.regSub('sub::nikeone.live.event', (db, [_, eventId]) => {
    return db.getIn(['nikeone', 'live', eventId]);
});

export const liveMatchPenaltiesHome$ = parametric(matchId =>
    subscription(db => db.getIn(['nikeone', 'live', matchId, 'match', 'penalties', 'home']))
);

export const liveMatchPenaltiesAway$ = parametric(matchId =>
    subscription(db => db.getIn(['nikeone', 'live', matchId, 'match', 'penalties', 'away']))
);

export const tlvBetsByMatchId$ = matchId => pathSubscription(['turboLive', 'overview', 'match2bets', matchId]);
